import gql from 'graphql-tag'

export const skillDescriptionQuery = gql`
  query SkillDescription($skillName: String!) {
    skillDescription(skillName: $skillName)
  }
`
